"use strict";

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Log_1 = require("../../../../Log");

var Links_1 = require("../utils/Links");

var AbstractVideoEmbedder_1 = require("./AbstractVideoEmbedder");

var YoutubeEmbedder =
/*#__PURE__*/
function (_AbstractVideoEmbedde) {
  _inherits(YoutubeEmbedder, _AbstractVideoEmbedde);

  function YoutubeEmbedder() {
    _classCallCheck(this, YoutubeEmbedder);

    return _possibleConstructorReturn(this, _getPrototypeOf(YoutubeEmbedder).apply(this, arguments));
  }

  _createClass(YoutubeEmbedder, [{
    key: "markEmbedIfFound",
    value: function markEmbedIfFound(child) {
      try {
        var data = child.data;
        var yt = YoutubeEmbedder.getYoutubeMetadataFromLink(data);

        if (!yt) {
          return undefined;
        }

        var embedMarker = AbstractVideoEmbedder_1.AbstractVideoEmbedder.getEmbedMarker(yt.id, YoutubeEmbedder.TYPE);
        child.data = data.replace(yt.url, embedMarker);
        return {
          image: yt.thumbnail,
          link: yt.url
        };
      } catch (error) {
        Log_1.Log.log().error(error);
      }

      return undefined;
    }
  }, {
    key: "processEmbedIfRelevant",
    value: function processEmbedIfRelevant(embedType, id, size, htmlElementKey) {
      if (embedType !== YoutubeEmbedder.TYPE) return undefined;
      var ytUrl = "https://www.youtube.com/embed/".concat(id);
      return "<div class=\"videoWrapper\"><iframe\n                    width=\"".concat(size.width, "\"\n                    height=\"").concat(size.height, "\"\n                    src=\"").concat(ytUrl, "\"\n                    allowfullscreen=\"allowfullscreen\"\n                    webkitallowfullscreen=\"webkitallowfullscreen\"\n                    mozallowfullscreen=\"mozallowfullscreen\"\n                    frameborder=\"0\"\n                ></iframe></div>");
    }
  }], [{
    key: "getYoutubeMetadataFromLink",

    /** @return {id, url} or <b>null</b> */
    value: function getYoutubeMetadataFromLink(data) {
      if (!data) {
        return null;
      }

      var m1 = data.match(Links_1.default.youTube);
      var url = m1 ? m1[0] : null;

      if (!url) {
        return null;
      }

      var m2 = url.match(Links_1.default.youTubeId);
      var id = m2 && m2.length >= 2 ? m2[1] : null;

      if (!id) {
        return null;
      }

      return {
        id: id,
        url: url,
        thumbnail: "https://img.youtube.com/vi/" + id + "/0.jpg"
      };
    }
  }]);

  return YoutubeEmbedder;
}(AbstractVideoEmbedder_1.AbstractVideoEmbedder);

YoutubeEmbedder.TYPE = "youtube";
exports.YoutubeEmbedder = YoutubeEmbedder;